import { GoogleAnalyticsEventsService } from './../../../../services/google-analytics-events.service';
import { Component, OnChanges, Input, Output, EventEmitter, SimpleChanges} from '@angular/core';
import { forEach } from '@angular/router/src/utils/collection';

@Component({
  selector: 'app-facet',
  templateUrl: './facet.component.html',
  styleUrls: ['./facet.component.scss']
})
export class FacetComponent implements OnChanges {
  @Input() name: string;
  @Input() title: string;
  @Input() index: string;
  @Input() items: any[];
  @Input() facetMap: any;
  @Input() searchOptions: any;
  @Input() pageName: string;
  @Input() enableSearchFilter: boolean;

  @Output() facetChanged: EventEmitter<object> = new EventEmitter();
  searchText: string;
  subFacetSelection = false;

  selected = false;

  constructor(private googleAnalyticsService: GoogleAnalyticsEventsService) {}

  /**
   * Process input changes, merge result facets with selections in facetMap
   * @param changes the input changes
   */
  ngOnChanges(changes: SimpleChanges) {
    if (changes.items && changes.items.currentValue) {

      this.items = changes.items.currentValue.map(item => {
        try {
          changes.facetMap.currentValue.forEach(facet => {
            // create and set selected property for item:
            if(!item.selected) {
              item.selected = (facet[changes.name.currentValue] || [])
                .filter(x => x.value === item.name).length > 0;

              // merge selected property for each sub item, from facetMap:
              if (item.selected && item.nestedFacetBag !== undefined) {
                item.nestedFacetBag = item.nestedFacetBag.map(x => {
                  x.selected = false;

                  // find item in facetMap for name/value:
                  const _facetMapItem = facet[changes.name.currentValue]
                    .filter(_item => _item.value === item.name)[0];

                  // nested item is selected if found in list:
                  if (_facetMapItem) {
                    x.selected = (_facetMapItem.nestedFacetBag || [])
                      .indexOf(x.name) > -1;
                  }

                  return x;

                });
              }

              // create expanded property for item:
              item.expanded = (item.nestedFacetBag)
                ? item.nestedFacetBag.filter(x => x.selected).length > 0
                : false;
            }
          });
          return item;

        } catch (error) {
          item.selected = false;
          console.error('facet.onchanges.item', this.name, item.name, error);
        }
      });
    }
  }

  /**
   * Subfacet item click handler, toggle the subitem selected
   * @param item the item clicked
   * @param sub the sub item clicked
   */
  onSubFacetClick(item, sub) {
    sub.selected = !sub.selected;
    item.selected = item.nestedFacetBag.filter(_sub => _sub.selected).length > 0;
    this.searchByFacet();
  }

  /**
   * Facet item click handler, toggle parent item and all children
   * @param item the clicked item
   */
  onFacetItemClick(item: any) {
    this.selected = !item.selected;
    item.selected = !item.selected;
    if (!item.selected && item.nestedFacetBag) {
      item.nestedFacetBag = item.nestedFacetBag.map(sub => {
        sub.selected = false; return sub;
      });
    }
    this.searchByFacet();
  }

  /**
   * Create the facet with selections to add to query
   */
  searchByFacet() {

    const items = this.items.filter(item => item.selected)
      .map(item => {

        // capture main item selection:
        const _facetItem: any = {
          value: item.name
        };

        // capture nested facet item selections:
        if (item.nestedFacetBag && item.nestedFacetBag.filter(x => x.selected).length > 0) {
          _facetItem.nestedFacetTypeName = item.nestedFacetTypeName,
          _facetItem.nestedFacetBag = item.nestedFacetBag
            .filter(sub => sub.selected)
            .map(sub => sub.name);
        }

      return _facetItem;
    });

    this.facetChanged.emit({
      name: this.name,
      value: items
    });

    this.googleAnalyticsService.emitEvent((this.pageName + ' Facets'), 'Check box checked', this.title);
    items.forEach(x => {
      if (x.hasOwnProperty('nestedFacetBag')) {
        this.subFacetSelection = true;
      }
    });
    if (this.subFacetSelection) {
      this.googleAnalyticsService.emitEvent((this.pageName + ' Facets'), 'Check box checked', ('Sub ' + this.title));
    }
  }

}
